import { combineReducers } from "redux";
import common from './commonReducer'
import loader from './loader/loaderReducer'

export default combineReducers({
  common,
  loader
})